import { err, ok, Result } from 'neverthrow';
import { TopAlbumResponse } from 'web-shared/src/types/lastfm';
import { ErrorWithCode, LastFmErrors } from 'web-shared/src/types/errors';
import { safeFetch } from 'web-shared/src/lib/fetch';
import { apiUrl } from 'web-shared/src/lib/api';

export const getRecentListens = async (): Promise<
  Result<TopAlbumResponse, ErrorWithCode<LastFmErrors>>
> => {
  const response = await safeFetch<TopAlbumResponse, LastFmErrors>(
    `${apiUrl}/lastfm/recent`,
    { method: 'GET' },
  );

  if (response.isErr()) {
    return err(response.error);
  }

  return ok(response.value);
};
